import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingCartinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.5 22a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1 3h4l3.783 12.294a1 1 0 0 0 .956.706h9.54a1 1 0 0 0 .949-.684l2.333-7A1 1 0 0 0 21.613 7H7",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgShoppingCartinline;
